/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/common";
import * as OM from '@/Model';
import { baseUrl } from '@/config';

class _AppleAuthClient {

        
    redirectAccessToken(
        token:string,showSpinner = true): Promise<OM.BaseApiLoginResponse> {
                return CommonServices.get<OM.BaseApiLoginResponse>(baseUrl + 'appleauth/appleTokenLogin',{ token  }, showSpinner);

            }
                }

export let AppleAuthClient = new _AppleAuthClient();

class _ArchivioClient {

        
    checkToRead(
        userIdentifier:string,showSpinner = true): Promise<boolean> {
                return CommonServices.get<boolean>(baseUrl + 'api/Archivio/CheckToRead',{ userIdentifier  }, showSpinner);

            }
        
        
    deleteNodes(
        vm:OM.DeleteNodesVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Archivio/DeleteNodes', vm ,{}, showSpinner );

            }
        
        
    getNamesByParent(
        parentIdentifier:string,showSpinner = true): Promise<OM.ValueIdentifierOfString[]> {
                return CommonServices.get<OM.ValueIdentifierOfString[]>(baseUrl + 'api/Archivio/GetNamesByParent',{ parentIdentifier  }, showSpinner);

            }
        
        
    save(
        vm:OM.EditNodeVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'api/Archivio/Save', vm ,{}, showSpinner );

            }
        
        
    addReadBy(
        nodeIdentifier:string,
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Archivio/AddReadBy',{ nodeIdentifier , userIdentifier  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.ArchivioNode> {
                return CommonServices.get<OM.ArchivioNode>(baseUrl + 'api/Archivio/GetById',{ identifier  }, showSpinner);

            }
        
        
    setNodeOrder(
        identifier:string,
        orderValue:number,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Archivio/SetNodeOrder',{ identifier , orderValue  }, showSpinner);

            }
        
        
    getChildrenOf(
        nodeIdentifier:string,
        userIdentifier:string,showSpinner = true): Promise<OM.ArchivioNodeVm[]> {
                return CommonServices.get<OM.ArchivioNodeVm[]>(baseUrl + 'api/Archivio/GetChildrenOf',{ nodeIdentifier , userIdentifier  }, showSpinner);

            }
                }

export let ArchivioClient = new _ArchivioClient();

class _AssetClient {

        
    getIdExcelList(showSpinner = true): Promise<number[]> {
                return CommonServices.get<number[]>(baseUrl + 'api/Asset/GetIdExcelList',{  }, showSpinner);

            }
        
        
    getAssetVmForChallengeList(showSpinner = true): Promise<OM.AssetVmForChallengeList[]> {
                return CommonServices.get<OM.AssetVmForChallengeList[]>(baseUrl + 'api/Asset/GetAssetVmForChallengeList',{  }, showSpinner);

            }
        
        
    getAll(showSpinner = true): Promise<OM.AssetVm[]> {
                return CommonServices.get<OM.AssetVm[]>(baseUrl + 'api/Asset/GetAll',{  }, showSpinner);

            }
        
        
    getAssetsForBuyList(
        filterVm:OM.AssetFilterVm,showSpinner = true): Promise<OM.AssetForBuyListVm[]> {
                return CommonServices.post<OM.AssetForBuyListVm[]>(baseUrl + 'api/Asset/GetAssetsForBuyList', filterVm ,{}, showSpinner );

            }
        
        
    getAssetClasses(
        filterVm:OM.AssetFilterVm,showSpinner = true): Promise<string[]> {
                return CommonServices.post<string[]>(baseUrl + 'api/Asset/GetAssetClasses', filterVm ,{}, showSpinner );

            }
        
        
    getPerformanceTableOfBenchmark(
        assetIdentifier:string,showSpinner = true): Promise<OM.AssetPerformanceByMonthVm[]> {
                return CommonServices.get<OM.AssetPerformanceByMonthVm[]>(baseUrl + 'api/Asset/GetPerformanceTableOfBenchmark',{ assetIdentifier  }, showSpinner);

            }
        
        
    getBenchmarkByMacroAndMicro(
        macroClass:string,
        microClass:string,showSpinner = true): Promise<OM.BenchmarkVm> {
                return CommonServices.get<OM.BenchmarkVm>(baseUrl + 'api/Asset/GetBenchmarkByMacroAndMicro',{ macroClass , microClass  }, showSpinner);

            }
        
        
    getValuteValues(showSpinner = true): Promise<{ [key: string]: number; }> {
                return CommonServices.get<{ [key: string]: number; }>(baseUrl + 'api/Asset/GetValuteValues',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.Asset> {
                return CommonServices.get<OM.Asset>(baseUrl + 'api/Asset/GetById',{ identifier  }, showSpinner);

            }
        
        
    getNav(
        assetIdentifier:string,showSpinner = true): Promise<OM.DateValue[]> {
                return CommonServices.get<OM.DateValue[]>(baseUrl + 'api/Asset/GetNav',{ assetIdentifier  }, showSpinner);

            }
        
        
    getVariazioneGiornaliera(
        assetIdentifier:string,showSpinner = true): Promise<OM.DateValue[]> {
                return CommonServices.get<OM.DateValue[]>(baseUrl + 'api/Asset/GetVariazioneGiornaliera',{ assetIdentifier  }, showSpinner);

            }
        
        
    getVolatilita(
        assetIdentifier:string,showSpinner = true): Promise<OM.DateValue[]> {
                return CommonServices.get<OM.DateValue[]>(baseUrl + 'api/Asset/GetVolatilita',{ assetIdentifier  }, showSpinner);

            }
        
        
    getPerformance(
        assetIdentifier:string,showSpinner = true): Promise<OM.DateValue[]> {
                return CommonServices.get<OM.DateValue[]>(baseUrl + 'api/Asset/GetPerformance',{ assetIdentifier  }, showSpinner);

            }
        
        
    getNameIdentifier(showSpinner = true): Promise<OM.ValueIdentifierOfString[]> {
                return CommonServices.get<OM.ValueIdentifierOfString[]>(baseUrl + 'api/Asset/GetNameIdentifier',{  }, showSpinner);

            }
        
        
    loadAssetsAndUpdateNavs(showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Asset/LoadAssetsAndUpdateNavs', {},{}, showSpinner );

            }
                }

export let AssetClient = new _AssetClient();

class _AssetInPortafoglioClient {

        
    getByUserBalanceIdentifier(
        userBalanceIdentifier:string,showSpinner = true): Promise<OM.AssetInPortafoglioVm[]> {
                return CommonServices.get<OM.AssetInPortafoglioVm[]>(baseUrl + 'api/AssetInPortafoglio/GetByUserBalanceIdentifier',{ userBalanceIdentifier  }, showSpinner);

            }
        
        
    getPortafoglioByFilter(
        filterVm:OM.AssetFilterVm,showSpinner = true): Promise<OM.AssetInPortafoglioVm[]> {
                return CommonServices.post<OM.AssetInPortafoglioVm[]>(baseUrl + 'api/AssetInPortafoglio/GetPortafoglioByFilter', filterVm ,{}, showSpinner );

            }
                }

export let AssetInPortafoglioClient = new _AssetInPortafoglioClient();

class _AuthClient {

        
    login(
        credentials:OM.LoginData,showSpinner = true): Promise<OM.LoginResponse> {
                return CommonServices.post<OM.LoginResponse>(baseUrl + 'api/Auth/Login', credentials ,{}, showSpinner );

            }
        
        
    checkAppVersion(
        appVersion:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Auth/CheckAppVersion',{ appVersion  }, showSpinner);

            }
        
        
    loginWithVersion(
        credentials:OM.LoginDataWithVersion,showSpinner = true): Promise<OM.LoginResponse> {
                return CommonServices.post<OM.LoginResponse>(baseUrl + 'api/Auth/LoginWithVersion', credentials ,{}, showSpinner );

            }
        
        
    register(
        credentials:OM.RegisterVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Auth/Register', credentials ,{}, showSpinner );

            }
        
        
    checkChangePasswordCode(
        email:string,
        code:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Auth/CheckChangePasswordCode',{ email , code  }, showSpinner);

            }
        
        
    changePassword(
        vm:OM.ChangePasswordVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Auth/ChangePassword', vm ,{}, showSpinner );

            }
        
        
    forgotPassword(
        email:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Auth/ForgotPassword',{ email  }, showSpinner);

            }
        
        
    confirmEmail(
        email:string,
        code:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Auth/ConfirmEmail',{ email , code  }, showSpinner);

            }
                }

export let AuthClient = new _AuthClient();

class _CaricamentoFileClient {

        
    loadLezioni(showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/CaricamentoFile/LoadLezioni', {},{}, showSpinner );

            }
        
        
    loadGlossario(showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/CaricamentoFile/LoadGlossario', {},{}, showSpinner );

            }
        
        
    loadAssets(showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/CaricamentoFile/LoadAssets', {},{}, showSpinner );

            }
        
        
    loadAssetsWithNav(showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/CaricamentoFile/LoadAssetsWithNav', {},{}, showSpinner );

            }
        
        
    loadNavsUntilDate(showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/CaricamentoFile/LoadNavsUntilDate', {},{}, showSpinner );

            }
        
        
    loadNavsUntilDateAndAdvance(showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/CaricamentoFile/LoadNavsUntilDateAndAdvance', {},{}, showSpinner );

            }
        
        
    loadOrdiniUtentiPortafogli(showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/CaricamentoFile/LoadOrdiniUtentiPortafogli', {},{}, showSpinner );

            }
                }

export let CaricamentoFileClient = new _CaricamentoFileClient();

class _ChallengeClient {

        
    save(
        chall:OM.Challenge,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'api/Challenge/Save', chall ,{}, showSpinner );

            }
        
        
    getAll(showSpinner = true): Promise<OM.Challenge[]> {
                return CommonServices.get<OM.Challenge[]>(baseUrl + 'api/Challenge/GetAll',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.Challenge> {
                return CommonServices.get<OM.Challenge>(baseUrl + 'api/Challenge/GetById',{ identifier  }, showSpinner);

            }
        
        
    getNameIdentifier(showSpinner = true): Promise<OM.ValueIdentifierOfString[]> {
                return CommonServices.get<OM.ValueIdentifierOfString[]>(baseUrl + 'api/Challenge/GetNameIdentifier',{  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Challenge/Delete',{ identifier  }, showSpinner);

            }
        
        
    getAllVm(showSpinner = true): Promise<OM.ChallengeVm[]> {
                return CommonServices.get<OM.ChallengeVm[]>(baseUrl + 'api/Challenge/GetAllVm',{  }, showSpinner);

            }
        
        
    getPartecipantsOfChallenge(
        challengeIdentifier:string,showSpinner = true): Promise<number> {
                return CommonServices.get<number>(baseUrl + 'api/Challenge/GetPartecipantsOfChallenge',{ challengeIdentifier  }, showSpinner);

            }
        
        
    countPlayersInChallenge(
        challengeIdentifier:string,showSpinner = true): Promise<number> {
                return CommonServices.get<number>(baseUrl + 'api/Challenge/CountPlayersInChallenge',{ challengeIdentifier  }, showSpinner);

            }
        
        
    getByUserPartecipating(
        userIdentifier:string,showSpinner = true): Promise<OM.ChallengeVm[]> {
                return CommonServices.get<OM.ChallengeVm[]>(baseUrl + 'api/Challenge/GetByUserPartecipating',{ userIdentifier  }, showSpinner);

            }
        
        
    getByUserNotPartecipating(
        userIdentifier:string,showSpinner = true): Promise<OM.ChallengeVm[]> {
                return CommonServices.get<OM.ChallengeVm[]>(baseUrl + 'api/Challenge/GetByUserNotPartecipating',{ userIdentifier  }, showSpinner);

            }
        
        
    getClosedChallenges(showSpinner = true): Promise<OM.ChallengeVm[]> {
                return CommonServices.get<OM.ChallengeVm[]>(baseUrl + 'api/Challenge/GetClosedChallenges',{  }, showSpinner);

            }
        
        
    getPremiByPeriods(showSpinner = true): Promise<OM.PremiUserGroupedVm[]> {
                return CommonServices.get<OM.PremiUserGroupedVm[]>(baseUrl + 'api/Challenge/GetPremiByPeriods',{  }, showSpinner);

            }
        
        
    assegnaPremi(
        vm:OM.AssegnaPremiVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Challenge/AssegnaPremi', vm ,{}, showSpinner );

            }
                }

export let ChallengeClient = new _ChallengeClient();

class _ChatClient {

        
    getByUserIdentifier(
        userIdentifier:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'api/Chat/GetByUserIdentifier',{ userIdentifier  }, showSpinner);

            }
        
        
    startChat(
        userIdentifier:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'api/Chat/StartChat',{ userIdentifier  }, showSpinner);

            }
        
        
    getChatMessages(
        chatIdentifier:string,
        skip:number,
        take:number,
        orderBy:number,showSpinner = true): Promise<OM.ChatMessage[]> {
                return CommonServices.get<OM.ChatMessage[]>(baseUrl + 'api/Chat/GetChatMessages',{ chatIdentifier , skip , take , orderBy  }, showSpinner);

            }
        
        
    getChatRooms(showSpinner = true): Promise<OM.ChatRoomVm[]> {
                return CommonServices.get<OM.ChatRoomVm[]>(baseUrl + 'api/Chat/GetChatRooms',{  }, showSpinner);

            }
        
        
    sendMessage(
        vm:OM.SendMessageVm,showSpinner = true): Promise<OM.ChatMessage> {
                return CommonServices.post<OM.ChatMessage>(baseUrl + 'api/Chat/SendMessage', vm ,{}, showSpinner );

            }
        
        
    removeMessage(
        chatRoomIdentifier:string,
        messageIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Chat/RemoveMessage',{ chatRoomIdentifier , messageIdentifier  }, showSpinner);

            }
        
        
    getMessagesFrom(
        chatRoomIdentifier:string,
        timestamp:number,showSpinner = true): Promise<OM.ChatMessage[]> {
                return CommonServices.get<OM.ChatMessage[]>(baseUrl + 'api/Chat/GetMessagesFrom',{ chatRoomIdentifier , timestamp  }, showSpinner);

            }
        
        
    checkNewMessages(
        userIdentifier:string,
        timestamp:number,showSpinner = true): Promise<number> {
                return CommonServices.get<number>(baseUrl + 'api/Chat/CheckNewMessages',{ userIdentifier , timestamp  }, showSpinner);

            }
        
        
    checkNewMessagesAllChats(showSpinner = true): Promise<{ [key: string]: number; }> {
                return CommonServices.get<{ [key: string]: number; }>(baseUrl + 'api/Chat/CheckNewMessagesAllChats',{  }, showSpinner);

            }
                }

export let ChatClient = new _ChatClient();

class _CinturaClient {

        
    getAll(showSpinner = true): Promise<OM.Cintura[]> {
                return CommonServices.get<OM.Cintura[]>(baseUrl + 'api/Cintura/GetAll',{  }, showSpinner);

            }
        
        
    getById(
        cinturaIdentifier:string,showSpinner = true): Promise<OM.Cintura> {
                return CommonServices.get<OM.Cintura>(baseUrl + 'api/Cintura/GetById',{ cinturaIdentifier  }, showSpinner);

            }
        
        
    getTotalCinture(showSpinner = true): Promise<number> {
                return CommonServices.get<number>(baseUrl + 'api/Cintura/GetTotalCinture',{  }, showSpinner);

            }
        
        
    save(
        cintura:OM.Cintura,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'api/Cintura/Save', cintura ,{}, showSpinner );

            }
        
    /**
     * @deprecated
     */
        
    getCintureWithTemi(showSpinner = true): Promise<OM.CinturaWithTemiVm[]> {
                return CommonServices.get<OM.CinturaWithTemiVm[]>(baseUrl + 'api/Cintura/GetCintureWithTemi',{  }, showSpinner);

            }
        
        
    getCintureWithTemiByPercorso(
        percorso:string,showSpinner = true): Promise<OM.CinturaWithTemiVm[]> {
                return CommonServices.get<OM.CinturaWithTemiVm[]>(baseUrl + 'api/Cintura/GetCintureWithTemiByPercorso',{ percorso  }, showSpinner);

            }
                }

export let CinturaClient = new _CinturaClient();

class _DomandaQualitaConfigClient {

        
    createDomandaQualitaConfig(showSpinner = true): Promise<OM.DomandaQualitaConfig> {
                return CommonServices.get<OM.DomandaQualitaConfig>(baseUrl + 'api/DomandaQualitaConfig/CreateDomandaQualitaConfig',{  }, showSpinner);

            }
        
        
    deleteDomandaQualitaConfig(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/DomandaQualitaConfig/DeleteDomandaQualitaConfig',{ identifier  }, showSpinner);

            }
        
        
    getAll(showSpinner = true): Promise<OM.DomandaQualitaConfig[]> {
                return CommonServices.get<OM.DomandaQualitaConfig[]>(baseUrl + 'api/DomandaQualitaConfig/GetAll',{  }, showSpinner);

            }
        
        
    save(
        domanda:OM.DomandaQualitaConfig,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/DomandaQualitaConfig/Save', domanda ,{}, showSpinner );

            }
                }

export let DomandaQualitaConfigClient = new _DomandaQualitaConfigClient();

class _ExportClient {

        
    exportXml(
        startFrom:string,
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Export/ExportXml',{ startFrom , psw  }, showSpinner);

            }
        
        
    getAssetData(showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Export/GetAssetData',{  }, showSpinner);

            }
                }

export let ExportClient = new _ExportClient();

class _FacebookAuthClient {

        
    facebookRedirectAccessToken(
        access_token:string,
        password:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'facebookauth/redirectaccesstoken',{ access_token , password  }, showSpinner);

            }
        
        
    facebookTokenLogin(
        vm:OM.ProviderTokenLoginVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'facebookauth/facebookTokenLogin', vm ,{}, showSpinner );

            }
                }

export let FacebookAuthClient = new _FacebookAuthClient();

class _FriendChallengeClient {

        
    getReceivedInvites(
        userIdentifier:string,
        challengeIdentifier:string,showSpinner = true): Promise<OM.FriendChallengeInvite[]> {
                return CommonServices.get<OM.FriendChallengeInvite[]>(baseUrl + 'api/FriendChallenge/GetReceivedInvites',{ userIdentifier , challengeIdentifier  }, showSpinner);

            }
        
        
    getInvitedPending(
        userIdentifier:string,
        friendChallengeIdentifier:string,showSpinner = true): Promise<OM.ValueIdentifierOfString[]> {
                return CommonServices.get<OM.ValueIdentifierOfString[]>(baseUrl + 'api/FriendChallenge/GetInvitedPending',{ userIdentifier , friendChallengeIdentifier  }, showSpinner);

            }
        
        
    getFriendChallengeVm(
        friendChallengeIdentifier:string,showSpinner = true): Promise<OM.FriendChallengeListVm> {
                return CommonServices.get<OM.FriendChallengeListVm>(baseUrl + 'api/FriendChallenge/GetFriendChallengeVm',{ friendChallengeIdentifier  }, showSpinner);

            }
        
        
    acceptInvite(
        inviteIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/FriendChallenge/AcceptInvite',{ inviteIdentifier  }, showSpinner);

            }
        
        
    denyInvite(
        inviteIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/FriendChallenge/DenyInvite',{ inviteIdentifier  }, showSpinner);

            }
        
        
    createFriendChallenge(
        vm:OM.CreateFriendChallengeVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'api/FriendChallenge/CreateFriendChallenge', vm ,{}, showSpinner );

            }
        
        
    updateFriendChallenge(
        vm:OM.CreateFriendChallengeVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'api/FriendChallenge/UpdateFriendChallenge', vm ,{}, showSpinner );

            }
        
        
    deleteInvite(
        inviteIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/FriendChallenge/DeleteInvite',{ inviteIdentifier  }, showSpinner);

            }
        
        
    getById(
        challengeIdentifier:string,showSpinner = true): Promise<OM.FriendChallenge> {
                return CommonServices.get<OM.FriendChallenge>(baseUrl + 'api/FriendChallenge/GetById',{ challengeIdentifier  }, showSpinner);

            }
        
        
    getFriendChallengeRankings(
        challengeIdentifier:string,showSpinner = true): Promise<OM.RankingCardVm[]> {
                return CommonServices.get<OM.RankingCardVm[]>(baseUrl + 'api/FriendChallenge/GetFriendChallengeRankings',{ challengeIdentifier  }, showSpinner);

            }
        
        
    getByUser(
        userIdentifier:string,
        challengeIdentifier:string,showSpinner = true): Promise<OM.FriendChallengeVm[]> {
                return CommonServices.get<OM.FriendChallengeVm[]>(baseUrl + 'api/FriendChallenge/GetByUser',{ userIdentifier , challengeIdentifier  }, showSpinner);

            }
                }

export let FriendChallengeClient = new _FriendChallengeClient();

class _GlobalConfigClient {

        
    caricaComuni(showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/GlobalConfig/CaricaComuni', {},{}, showSpinner );

            }
        
        
    getConfig(showSpinner = true): Promise<OM.GlobalConfig> {
                return CommonServices.get<OM.GlobalConfig>(baseUrl + 'api/GlobalConfig/GetConfig',{  }, showSpinner);

            }
        
        
    saveConfig(
        config:OM.GlobalConfig,showSpinner = true): Promise<OM.GlobalConfig> {
                return CommonServices.post<OM.GlobalConfig>(baseUrl + 'api/GlobalConfig/SaveConfig', config ,{}, showSpinner );

            }
        
        
    getDizionario(showSpinner = true): Promise<OM.TimedDictionaryOfStringAndString> {
                return CommonServices.get<OM.TimedDictionaryOfStringAndString>(baseUrl + 'api/GlobalConfig/GetDizionario',{  }, showSpinner);

            }
        
        
    getDizionarioHtml(showSpinner = true): Promise<{ [key: string]: string; }> {
                return CommonServices.get<{ [key: string]: string; }>(baseUrl + 'api/GlobalConfig/GetDizionarioHtml',{  }, showSpinner);

            }
        
        
    getTimedDizionario(
        timestamp:number,showSpinner = true): Promise<OM.TimedDictionaryOfStringAndString> {
                return CommonServices.get<OM.TimedDictionaryOfStringAndString>(baseUrl + 'api/GlobalConfig/GetTimedDizionario',{ timestamp  }, showSpinner);

            }
        
        
    getTimedDizionarioHtml(
        timestamp:number,showSpinner = true): Promise<OM.TimedDictionaryOfStringAndString> {
                return CommonServices.get<OM.TimedDictionaryOfStringAndString>(baseUrl + 'api/GlobalConfig/GetTimedDizionarioHtml',{ timestamp  }, showSpinner);

            }
        
        
    getUserInfoConfig(showSpinner = true): Promise<OM.QuestionarioInizialeConfig> {
                return CommonServices.get<OM.QuestionarioInizialeConfig>(baseUrl + 'api/GlobalConfig/GetUserInfoConfig',{  }, showSpinner);

            }
        
        
    getRegioni(showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'api/GlobalConfig/GetRegioni',{  }, showSpinner);

            }
        
        
    getProvince(
        regione:string,showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'api/GlobalConfig/GetProvince',{ regione  }, showSpinner);

            }
        
        
    getComuni(
        provincia:string,showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'api/GlobalConfig/GetComuni',{ provincia  }, showSpinner);

            }
        
        
    getSystemDate(showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'api/GlobalConfig/GetSystemDate',{  }, showSpinner);

            }
                }

export let GlobalConfigClient = new _GlobalConfigClient();

class _GlossarioClient {

        
    getAll(showSpinner = true): Promise<OM.GlossarioGroupVm[]> {
                return CommonServices.get<OM.GlossarioGroupVm[]>(baseUrl + 'api/Glossario/GetAll',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.Glossario> {
                return CommonServices.get<OM.Glossario>(baseUrl + 'api/Glossario/GetById',{ identifier  }, showSpinner);

            }
        
        
    getByKey(
        key:string,showSpinner = true): Promise<OM.Glossario> {
                return CommonServices.get<OM.Glossario>(baseUrl + 'api/Glossario/GetByKey',{ key  }, showSpinner);

            }
        
        
    save(
        entry:OM.Glossario,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Glossario/Save', entry ,{}, showSpinner );

            }
                }

export let GlossarioClient = new _GlossarioClient();

class _GoogleAuthClient {

        
    checkClientId(
        idToken:string,
        password:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'googleauth/checkIdToken',{ idToken , password  }, showSpinner);

            }
        
        
    googleTokenLogin(
        vm:OM.ProviderTokenLoginVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'googleauth/googleTokenLogin', vm ,{}, showSpinner );

            }
                }

export let GoogleAuthClient = new _GoogleAuthClient();

class _ImageForLessonClient {

        
    uploadImage(showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'api/ImageForLesson/UploadImage', {},{}, showSpinner );

            }
        
        
    getAllGrouped(showSpinner = true): Promise<OM.ImageForLessonGroupVm[]> {
                return CommonServices.get<OM.ImageForLessonGroupVm[]>(baseUrl + 'api/ImageForLesson/GetAllGrouped',{  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/ImageForLesson/Delete',{ identifier  }, showSpinner);

            }
        
        
    deleteByName(
        fileName:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/ImageForLesson/DeleteByName',{ fileName  }, showSpinner);

            }
                }

export let ImageForLessonClient = new _ImageForLessonClient();

class _LezioneClient {

        
    getById(
        identifier:string,showSpinner = true): Promise<OM.Lezione> {
                return CommonServices.get<OM.Lezione>(baseUrl + 'api/Lezione/GetById',{ identifier  }, showSpinner);

            }
        
        
    getByTemaIdentifier(
        temaIdentifier:string,showSpinner = true): Promise<OM.Lezione[]> {
                return CommonServices.get<OM.Lezione[]>(baseUrl + 'api/Lezione/GetByTemaIdentifier',{ temaIdentifier  }, showSpinner);

            }
        
    /**
     * @param temaIdentifier (optional) 
     * @deprecated
     */
        
    getGroupedByCintura(
        temaIdentifier:string,showSpinner = true): Promise<OM.LezioneGroupedVm[]> {
                return CommonServices.get<OM.LezioneGroupedVm[]>(baseUrl + 'api/Lezione/GetGroupedByCintura',{ temaIdentifier  }, showSpinner);

            }
        
        
    getGroupedByCinturaByPercorso(
        temaIdentifier:string,
        percorso:string,showSpinner = true): Promise<OM.LezioneGroupedVm[]> {
                return CommonServices.get<OM.LezioneGroupedVm[]>(baseUrl + 'api/Lezione/GetGroupedByCinturaByPercorso',{ temaIdentifier , percorso  }, showSpinner);

            }
        
        
    save(
        lezione:OM.Lezione,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'api/Lezione/Save', lezione ,{}, showSpinner );

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Lezione/Delete',{ identifier  }, showSpinner);

            }
        
        
    generatePollyAudio(
        vm:OM.GeneratePollyVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Lezione/GeneratePollyAudio', vm ,{}, showSpinner );

            }
        
        
    getAllLezioni(showSpinner = true): Promise<OM.Lezione[]> {
                return CommonServices.get<OM.Lezione[]>(baseUrl + 'api/Lezione/GetAllLezioni',{  }, showSpinner);

            }
                }

export let LezioneClient = new _LezioneClient();

class _LinkedInAuthClient {

        
    redirectCode(
        code:string,
        password:string,showSpinner = true): Promise<OM.LoginResponse> {
                return CommonServices.get<OM.LoginResponse>(baseUrl + 'linkedinauth/redirectcode',{ code , password  }, showSpinner);

            }
                }

export let LinkedInAuthClient = new _LinkedInAuthClient();

class _MagiaClient {

        
    createChatRooms(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/CreateChatRooms',{ psw  }, showSpinner);

            }
        
        
    sapienza(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/Sapienza',{ psw  }, showSpinner);

            }
        
        
    insertIdExcelInLezioniSuperate(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/InsertIdExcelInLezioniSuperate',{ psw  }, showSpinner);

            }
        
        
    convertToIdExcel(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/ConvertToIdExcel',{ psw  }, showSpinner);

            }
        
        
    convertRisposteQualita(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/ConvertRisposteQualita',{ psw  }, showSpinner);

            }
        
        
    convertRisultatoQuestionario(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/ConvertRisultatoQuestionario',{ psw  }, showSpinner);

            }
        
        
    ensureAssetInPortafoglioData(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/EnsureAssetInPortafoglioData',{ psw  }, showSpinner);

            }
        
        
    regolaOffsetOrdini(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/RegolaOffsetOrdini',{ psw  }, showSpinner);

            }
        
        
    setAssetTypeInOrdini(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/SetAssetTypeInOrdini',{ psw  }, showSpinner);

            }
        
        
    fixDataMovimentoInOrdini(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/FixDataMovimentoInOrdini',{ psw  }, showSpinner);

            }
        
        
    setAssetTypesInPortafoglio(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/SetAssetTypesInPortafoglio',{ psw  }, showSpinner);

            }
        
        
    setChallengeNameInPremiUser(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/SetChallengeNameInPremiUser',{ psw  }, showSpinner);

            }
        
        
    risalvaCards(
        psw:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Magia/RisalvaCards',{ psw  }, showSpinner);

            }
                }

export let MagiaClient = new _MagiaClient();

class _MovimentoClient {

        
    getByUserBalanceIdentifier(
        userBalanceIdentifier:string,showSpinner = true): Promise<OM.Movimento[]> {
                return CommonServices.get<OM.Movimento[]>(baseUrl + 'api/Movimento/GetByUserBalanceIdentifier',{ userBalanceIdentifier  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Movimento/Delete',{ identifier  }, showSpinner);

            }
                }

export let MovimentoClient = new _MovimentoClient();

class _OrdineClient {

        
    getByUserBalanceIdentifier(
        userBalanceIdentifier:string,showSpinner = true): Promise<OM.Ordine[]> {
                return CommonServices.get<OM.Ordine[]>(baseUrl + 'api/Ordine/GetByUserBalanceIdentifier',{ userBalanceIdentifier  }, showSpinner);

            }
        
        
    creaOrdine(
        creaOrdineVm:OM.CreaOrdineVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Ordine/CreaOrdine', creaOrdineVm ,{}, showSpinner );

            }
        
        
    creaSwitch(
        vm:OM.CreaSwitchVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Ordine/CreaSwitch', vm ,{}, showSpinner );

            }
        
        
    getOrdiniPendingWithSwitch(
        portafoglioIdentifier:string,
        assetType:string,showSpinner = true): Promise<OM.GetOrdiniPendingResponseVm> {
                return CommonServices.get<OM.GetOrdiniPendingResponseVm>(baseUrl + 'api/Ordine/GetOrdiniPendingWithSwitch',{ portafoglioIdentifier , assetType  }, showSpinner);

            }
        
    /**
     * @param portafoglioIdentifier (optional) 
     * @param assetType (optional) 
     * @deprecated
     */
        
    getOrdiniPending(
        portafoglioIdentifier:string,
        assetType:string,showSpinner = true): Promise<OM.OrdinePendingVm[]> {
                return CommonServices.get<OM.OrdinePendingVm[]>(baseUrl + 'api/Ordine/GetOrdiniPending',{ portafoglioIdentifier , assetType  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Ordine/Delete',{ identifier  }, showSpinner);

            }
        
        
    deleteMultiple(
        vm:OM.DeleteMultipleVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Ordine/DeleteMultiple', vm ,{}, showSpinner );

            }
                }

export let OrdineClient = new _OrdineClient();

class _PortafoglioClient {

        
    createNewBalance(
        balanceVm:OM.CreateUserBalanceVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'api/Portafoglio/CreateNewBalance', balanceVm ,{}, showSpinner );

            }
        
        
    getUserChallenges(
        userIdentifier:string,showSpinner = true): Promise<OM.ValueIdentifierOfGuid[]> {
                return CommonServices.get<OM.ValueIdentifierOfGuid[]>(baseUrl + 'api/Portafoglio/GetUserChallenges',{ userIdentifier  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.Portafoglio> {
                return CommonServices.get<OM.Portafoglio>(baseUrl + 'api/Portafoglio/GetById',{ identifier  }, showSpinner);

            }
        
        
    getDataForCalcoloAcquistoWithSwitch(
        vm:OM.GetDataForCalcoloAcquistoVm,showSpinner = true): Promise<OM.DataForCalcoloAcquistoVm> {
                return CommonServices.post<OM.DataForCalcoloAcquistoVm>(baseUrl + 'api/Portafoglio/GetDataForCalcoloAcquistoWithSwitch', vm ,{}, showSpinner );

            }
        
    /**
     * @param portafoglioIdentifier (optional) 
     * @param assetIdentifier (optional) 
     * @deprecated
     */
        
    getDataForCalcoloAcquisto(
        portafoglioIdentifier:string,
        assetIdentifier:string,showSpinner = true): Promise<OM.DataForCalcoloAcquistoVm> {
                return CommonServices.get<OM.DataForCalcoloAcquistoVm>(baseUrl + 'api/Portafoglio/GetDataForCalcoloAcquisto',{ portafoglioIdentifier , assetIdentifier  }, showSpinner);

            }
        
        
    getPortafoglioStatusWithSwitch(
        vm:OM.GetPortafoglioStatusWithSwitchVm,showSpinner = true): Promise<OM.PortafoglioStatusVm> {
                return CommonServices.post<OM.PortafoglioStatusVm>(baseUrl + 'api/Portafoglio/GetPortafoglioStatusWithSwitch', vm ,{}, showSpinner );

            }
        
    /**
     * @param portafoglioIdentifier (optional) 
     * @deprecated
     */
        
    getPortafoglioStatus(
        portafoglioIdentifier:string,showSpinner = true): Promise<OM.PortafoglioStatusVm> {
                return CommonServices.get<OM.PortafoglioStatusVm>(baseUrl + 'api/Portafoglio/GetPortafoglioStatus',{ portafoglioIdentifier  }, showSpinner);

            }
        
        
    getPortafoglioAssetClasses(
        filterVm:OM.AssetFilterVm,showSpinner = true): Promise<string[]> {
                return CommonServices.post<string[]>(baseUrl + 'api/Portafoglio/GetPortafoglioAssetClasses', filterVm ,{}, showSpinner );

            }
        
        
    getResocontoPortafoglio(
        filterVm:OM.AssetFilterVm,showSpinner = true): Promise<OM.ResocontoPortafoglio> {
                return CommonServices.post<OM.ResocontoPortafoglio>(baseUrl + 'api/Portafoglio/GetResocontoPortafoglio', filterVm ,{}, showSpinner );

            }
        
        
    getResocontoAssets(
        portafoglioIdentifier:string,
        assetType:string,
        macroClass:string,
        microClass:string,
        untilDate:string,showSpinner = true): Promise<OM.ResocontoPortafoglio> {
                return CommonServices.get<OM.ResocontoPortafoglio>(baseUrl + 'api/Portafoglio/GetResocontoAssets',{ portafoglioIdentifier , assetType , macroClass , microClass , untilDate  }, showSpinner);

            }
        
        
    getAnalysis(
        filterVm:OM.AssetFilterVm,showSpinner = true): Promise<OM.KeyValuePairOfStringAndResocontoPortafoglio[]> {
                return CommonServices.post<OM.KeyValuePairOfStringAndResocontoPortafoglio[]>(baseUrl + 'api/Portafoglio/GetAnalysis', filterVm ,{}, showSpinner );

            }
        
        
    getDonutChartTypes(
        filterVm:OM.AssetFilterVm,showSpinner = true): Promise<OM.TypeForDonutChartVm[]> {
                return CommonServices.post<OM.TypeForDonutChartVm[]>(baseUrl + 'api/Portafoglio/GetDonutChartTypes', filterVm ,{}, showSpinner );

            }
        
        
    getDonutChart(
        filterVm:OM.AssetFilterVm,showSpinner = true): Promise<OM.AssetForDonutChart[]> {
                return CommonServices.post<OM.AssetForDonutChart[]>(baseUrl + 'api/Portafoglio/GetDonutChart', filterVm ,{}, showSpinner );

            }
        
        
    getAssetsVm(
        portafoglioIdentifier:string,showSpinner = true): Promise<OM.AssetVm[]> {
                return CommonServices.get<OM.AssetVm[]>(baseUrl + 'api/Portafoglio/GetAssetsVm',{ portafoglioIdentifier  }, showSpinner);

            }
        
        
    getAssetClasses(
        filterVm:OM.AssetFilterVm,showSpinner = true): Promise<string[]> {
                return CommonServices.post<string[]>(baseUrl + 'api/Portafoglio/GetAssetClasses', filterVm ,{}, showSpinner );

            }
        
        
    getAssetsForAnalysis(
        filterVm:OM.AssetFilterVm,showSpinner = true): Promise<OM.KeyValuePairOfStringAndResocontoPortafoglio[]> {
                return CommonServices.post<OM.KeyValuePairOfStringAndResocontoPortafoglio[]>(baseUrl + 'api/Portafoglio/GetAssetsForAnalysis', filterVm ,{}, showSpinner );

            }
        
        
    getByUserIdentifier(
        userIdentifier:string,showSpinner = true): Promise<OM.Portafoglio[]> {
                return CommonServices.get<OM.Portafoglio[]>(baseUrl + 'api/Portafoglio/GetByUserIdentifier',{ userIdentifier  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Portafoglio/Delete',{ identifier  }, showSpinner);

            }
                }

export let PortafoglioClient = new _PortafoglioClient();

class _ProgressiUserClient {

        
    getByUserIdentifier(
        userIdentifier:string,showSpinner = true): Promise<OM.ProgressiUser> {
                return CommonServices.get<OM.ProgressiUser>(baseUrl + 'api/ProgressiUser/GetByUserIdentifier',{ userIdentifier  }, showSpinner);

            }
        
        
    clearProgressi(showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/ProgressiUser/ClearProgressi',{  }, showSpinner);

            }
                }

export let ProgressiUserClient = new _ProgressiUserClient();

class _PushNotificationClient {

        
    sendPushNotification(
        pushVm:OM.SendPushConfigVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/PushNotification/SendPushNotification', pushVm ,{}, showSpinner );

            }
        
        
    sendToAll(
        pushVm:OM.SendPushConfigVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/PushNotification/SendToAll', pushVm ,{}, showSpinner );

            }
                }

export let PushNotificationClient = new _PushNotificationClient();

class _RankingCardClient {

        
    getRankings(
        challengeIdentifier:string,
        filter:string,showSpinner = true): Promise<OM.RankingCardVm[]> {
                return CommonServices.get<OM.RankingCardVm[]>(baseUrl + 'api/RankingCard/GetRankings',{ challengeIdentifier , filter  }, showSpinner);

            }
        
        
    getRankingsWithFilter(
        vm:OM.RankingFilterVm,showSpinner = true): Promise<OM.RankingCardVm[]> {
                return CommonServices.post<OM.RankingCardVm[]>(baseUrl + 'api/RankingCard/GetRankingsWithFilter', vm ,{}, showSpinner );

            }
                }

export let RankingCardClient = new _RankingCardClient();

class _RispostaQualitaClient {

        
    getAll(showSpinner = true): Promise<OM.RispostaQualita[]> {
                return CommonServices.get<OM.RispostaQualita[]>(baseUrl + 'api/RispostaQualita/GetAll',{  }, showSpinner);

            }
        
        
    save(
        vm:OM.RispostaQualitaVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'api/RispostaQualita/Save', vm ,{}, showSpinner );

            }
        
        
    checkRispostaQualita(
        lezioneIdentifier:string,
        userIdentifier:string,showSpinner = true): Promise<boolean> {
                return CommonServices.get<boolean>(baseUrl + 'api/RispostaQualita/CheckRispostaQualita',{ lezioneIdentifier , userIdentifier  }, showSpinner);

            }
                }

export let RispostaQualitaClient = new _RispostaQualitaClient();

class _RisultatoQuestionarioClient {

        
    save(
        vm:OM.RisultatoQuestionarioVm,showSpinner = true): Promise<OM.SaveQuestionarioResponseVm> {
                return CommonServices.post<OM.SaveQuestionarioResponseVm>(baseUrl + 'api/RisultatoQuestionario/Save', vm ,{}, showSpinner );

            }
        
        
    getByUserIdentifier(
        userIdentifier:string,showSpinner = true): Promise<OM.RisultatoQuestionario[]> {
                return CommonServices.get<OM.RisultatoQuestionario[]>(baseUrl + 'api/RisultatoQuestionario/GetByUserIdentifier',{ userIdentifier  }, showSpinner);

            }
                }

export let RisultatoQuestionarioClient = new _RisultatoQuestionarioClient();

class _SimulationClient {

        
    processMovimenti(
        toDate:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Simulation/ProcessMovimenti',{ toDate  }, showSpinner);

            }
        
        
    advanceDayByDayFromDate(
        fromDate:string,
        toDate:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Simulation/AdvanceDayByDayFromDate',{ fromDate , toDate  }, showSpinner);

            }
        
        
    advanceOneDay(

        inviaPush:boolean,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Simulation/AdvanceOneDay',{ inviaPush  }, showSpinner);

            }
                }

export let SimulationClient = new _SimulationClient();

class _TemaClient {

        
    getById(
        identifier:string,showSpinner = true): Promise<OM.Tema> {
                return CommonServices.get<OM.Tema>(baseUrl + 'api/Tema/GetById',{ identifier  }, showSpinner);

            }
        
        
    getTemiWithLezioni(
        cinturaIdentifier:string,showSpinner = true): Promise<OM.TemaWithLezioni[]> {
                return CommonServices.get<OM.TemaWithLezioni[]>(baseUrl + 'api/Tema/GetTemiWithLezioni',{ cinturaIdentifier  }, showSpinner);

            }
        
        
    getByCinturaIdentifier(
        cinturaIdentifier:string,showSpinner = true): Promise<OM.Tema[]> {
                return CommonServices.get<OM.Tema[]>(baseUrl + 'api/Tema/GetByCinturaIdentifier',{ cinturaIdentifier  }, showSpinner);

            }
        
    /**
     * @param temaIdentifier (optional) 
     * @param cinturaIdentifier (optional) 
     * @deprecated
     */
        
    getTemaVm(
        temaIdentifier:string,
        cinturaIdentifier:string,showSpinner = true): Promise<OM.TemaVm> {
                return CommonServices.get<OM.TemaVm>(baseUrl + 'api/Tema/GetTemaVm',{ temaIdentifier , cinturaIdentifier  }, showSpinner);

            }
        
        
    getTemaVmByPercorso(
        temaIdentifier:string,
        cinturaIdentifier:string,
        percorso:string,showSpinner = true): Promise<OM.TemaVm> {
                return CommonServices.get<OM.TemaVm>(baseUrl + 'api/Tema/GetTemaVmByPercorso',{ temaIdentifier , cinturaIdentifier , percorso  }, showSpinner);

            }
        
        
    save(
        tema:OM.Tema,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Tema/Save', tema ,{}, showSpinner );

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Tema/Delete',{ identifier  }, showSpinner);

            }
                }

export let TemaClient = new _TemaClient();

class _TemplateClient {

        
    save(
        item:OM.Template,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'api/Template/Save', item ,{}, showSpinner );

            }
        
        
    getAll(showSpinner = true): Promise<OM.Template[]> {
                return CommonServices.get<OM.Template[]>(baseUrl + 'api/Template/GetAll',{  }, showSpinner);

            }
        
        
    getNameIdentifier(showSpinner = true): Promise<OM.ValueIdentifierOfString[]> {
                return CommonServices.get<OM.ValueIdentifierOfString[]>(baseUrl + 'api/Template/GetNameIdentifier',{  }, showSpinner);

            }
        
        
    getContentVariables(showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'api/Template/GetContentVariables',{  }, showSpinner);

            }
                }

export let TemplateClient = new _TemplateClient();

class _TokenClient {

        
    login(
        authUserRequest:OM.BaseCredential,showSpinner = true): Promise<OM.LoginResponse> {
                return CommonServices.post<OM.LoginResponse>(baseUrl + 'api/Token/Login', authUserRequest ,{}, showSpinner );

            }
        
        
    checkLogin(showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/Token/CheckLogin',{  }, showSpinner);

            }
        
        
    checkLoginWithVersion(
        appVersion:string,showSpinner = true): Promise<OM.LoginResponse> {
                return CommonServices.get<OM.LoginResponse>(baseUrl + 'api/Token/CheckLoginWithVersion',{ appVersion  }, showSpinner);

            }
                }

export let TokenClient = new _TokenClient();

class _UserClient {

        
    getForTable(showSpinner = true): Promise<OM.UserVm[]> {
                return CommonServices.get<OM.UserVm[]>(baseUrl + 'api/User/GetForTable',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.User> {
                return CommonServices.get<OM.User>(baseUrl + 'api/User/GetById',{ identifier  }, showSpinner);

            }
        
        
    checkQuestionarioIniziale(
        userIdentifier:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'api/User/CheckQuestionarioIniziale',{ userIdentifier  }, showSpinner);

            }
        
        
    setQuestionarioIniziale(
        userIdentifier:string,

        done:boolean,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/User/SetQuestionarioIniziale',{ userIdentifier , done  }, showSpinner);

            }
        
        
    save(
        user:OM.User,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'api/User/Save', user ,{}, showSpinner );

            }
        
        
    setProfileImageAsFacebookDefault(showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/User/SetProfileImageAsFacebookDefault',{  }, showSpinner);

            }
        
        
    updateProfileImage(
        file:OM.FileParameter,showSpinner = true, progressFn: (prog) => void): Promise<string> {
                return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/User/UpdateProfileImage', file , progressFn );

            }
        
        
    setFcmId(
        fcmIdValue:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/User/setFcmId',{ fcmIdValue  }, showSpinner);

            }
        
        
    getProfile(showSpinner = true): Promise<OM.ProfileVm> {
                return CommonServices.get<OM.ProfileVm>(baseUrl + 'api/User/GetProfile',{  }, showSpinner);

            }
        
        
    saveProfile(
        vm:OM.ProfileVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/User/SaveProfile', vm ,{}, showSpinner );

            }
        
        
    checkPlayDisclaimer(
        userIdentifier:string,showSpinner = true): Promise<boolean> {
                return CommonServices.get<boolean>(baseUrl + 'api/User/CheckPlayDisclaimer',{ userIdentifier  }, showSpinner);

            }
        
        
    acceptPlayDisclaimer(
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/User/AcceptPlayDisclaimer',{ userIdentifier  }, showSpinner);

            }
                }

export let UserClient = new _UserClient();

class _ValuesClient {

        
    get(showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'api/Values',{  }, showSpinner);

            }
                }

export let ValuesClient = new _ValuesClient();

interface FileParameter {
    data: any;
    fileName: string;
}

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}